import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import classNames from 'classnames';

export default function MobileTaskSize(props) {
  const {setSelectedSize} = props;
  const [activeSize, setActiveSize] = useState('Small');
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const taskSizes = [
    'Extra small',
    'Small',
    'Medium',
    'Large'
  ];
  const onResize = (e) => {
    setTimeout(() => {
      setWindowSize(e.target.innerWidth);
    }, 500);
  }

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    }
  }, []);

  return (
    <Fragment>
      {windowSize < 1024 && (
        <Fragment>
          <span className="task-size-label">Task size</span>
          <div className="mobile-task-size">
            {taskSizes.map(size => {
              return (
                <button
                  className={classNames('mobile-task-size__item', {
                    'mobile-task-size__item--active': activeSize === size,
                  })}
                  type="button"
                  key={size}
                  onClick={() => {
                    setActiveSize(size);
                    setSelectedSize(size);
                  }}
                >
                  {size}
                </button>
              )
            })}
          </div>
        </Fragment>
      )}
    </Fragment>
  )
}
